import * as THREE from 'three'
import trafficlight_png from '@/components/images/trafficlight.png'
import roadSignLeftSvg from '@/assets/images/roadSign/LEFT.svg'
import roadSignLeftRightSvg from '@/assets/images/roadSign/LEFT_RIGHT.svg'
import roadSignLeftUTurnSvg from '@/assets/images/roadSign/LEFT_UTURN.svg'
import roadSignStraightLeftSvg from '@/assets/images/roadSign/STRAIGHT_LEFT.svg'
import roadSignStraightLeftRightSvg from '@/assets/images/roadSign/STRAIGHT_LEFT_RIGHT.svg'
import roadSignStraightSvg from '@/assets/images/roadSign/STRAIGHT.svg'
import roadSignStraightUTurnSvg from '@/assets/images/roadSign/STRAIGHT_UTURN.svg'
import roadSignUTurnSvg from '@/assets/images/roadSign/UTURN.svg'
import { createSpriteText_map } from '@/utils/labeltext.js'
import { createLine, createMesh, createLine_boundary, createLinePath } from './map_local'
import { disposeO3D, disposeO3D_child } from "./threejsHelper"
import { store } from '@/store/index'
import { createMeshFromLine } from '@/utils/threejsHelper'

let elementSetting = null;
let scene_global = null;
let mapLabelMap = new Map()
let mapLabelMap_visible = true
let roadMarkLocalLaneList = null
const roadMarkForwardCache = new Map()
const ROAD_MARK_LANE_MATCH_THRESHOLD = 2.5

const ROAD_MARK_TYPE_ENUM = {
    0: 'UNKNOWN',
    1: 'BIKE',
    2: 'DIAMOND',
    3: 'LEFT',
    4: 'LEFT_RIGHT',
    5: 'LEFT_UTURN',
    6: 'RIGHT',
    7: 'STRAIGHT',
    8: 'STRAIGHT_LEFT',
    9: 'STRAIGHT_LEFT_RIGHT',
    10: 'STRAIGHT_RIGHT',
    11: 'STRAIGHT_UTURN',
    12: 'UTURN',
    15: 'NO_STRAIGHT',
    16: 'NO_LEFT',
    17: 'NO_RIGHT',
    18: 'NO_UTURN',
}

const roadSignLeftTexture = new THREE.TextureLoader().load(roadSignLeftSvg)
roadSignLeftTexture.colorSpace = THREE.SRGBColorSpace

const roadSignLeftMaterial = new THREE.MeshBasicMaterial({
    map: roadSignLeftTexture,
    transparent: true,
    side: THREE.DoubleSide,
    depthTest: false,
})

const roadSignLeftRightTexture = new THREE.TextureLoader().load(roadSignLeftRightSvg)
roadSignLeftRightTexture.colorSpace = THREE.SRGBColorSpace

const roadSignLeftRightMaterial = new THREE.MeshBasicMaterial({
    map: roadSignLeftRightTexture,
    transparent: true,
    side: THREE.DoubleSide,
    depthTest: false,
})

const roadSignLeftUTurnTexture = new THREE.TextureLoader().load(roadSignLeftUTurnSvg)
roadSignLeftUTurnTexture.colorSpace = THREE.SRGBColorSpace

const roadSignLeftUTurnMaterial = new THREE.MeshBasicMaterial({
    map: roadSignLeftUTurnTexture,
    transparent: true,
    side: THREE.DoubleSide,
    depthTest: false,
})

const roadSignStraightLeftTexture = new THREE.TextureLoader().load(roadSignStraightLeftSvg)
roadSignStraightLeftTexture.colorSpace = THREE.SRGBColorSpace

const roadSignStraightLeftMaterial = new THREE.MeshBasicMaterial({
    map: roadSignStraightLeftTexture,
    transparent: true,
    side: THREE.DoubleSide,
    depthTest: false,
})

const roadSignStraightLeftRightTexture = new THREE.TextureLoader().load(roadSignStraightLeftRightSvg)
roadSignStraightLeftRightTexture.colorSpace = THREE.SRGBColorSpace

const roadSignStraightLeftRightMaterial = new THREE.MeshBasicMaterial({
    map: roadSignStraightLeftRightTexture,
    transparent: true,
    side: THREE.DoubleSide,
    depthTest: false,
})

const roadSignStraightTexture = new THREE.TextureLoader().load(roadSignStraightSvg)
roadSignStraightTexture.colorSpace = THREE.SRGBColorSpace

const roadSignStraightMaterial = new THREE.MeshBasicMaterial({
    map: roadSignStraightTexture,
    transparent: true,
    side: THREE.DoubleSide,
    depthTest: false,
})

const roadSignStraightUTurnTexture = new THREE.TextureLoader().load(roadSignStraightUTurnSvg)
roadSignStraightUTurnTexture.colorSpace = THREE.SRGBColorSpace

const roadSignStraightUTurnMaterial = new THREE.MeshBasicMaterial({
    map: roadSignStraightUTurnTexture,
    transparent: true,
    side: THREE.DoubleSide,
    depthTest: false,
})

const roadSignUTurnTexture = new THREE.TextureLoader().load(roadSignUTurnSvg)
roadSignUTurnTexture.colorSpace = THREE.SRGBColorSpace

const roadSignUTurnMaterial = new THREE.MeshBasicMaterial({
    map: roadSignUTurnTexture,
    transparent: true,
    side: THREE.DoubleSide,
    depthTest: false,
})

const ROAD_MARK_SIGN_MATERIAL_BY_TYPE = {
    LEFT: roadSignLeftMaterial,
    LEFT_RIGHT: roadSignLeftRightMaterial,
    LEFT_UTURN: roadSignLeftUTurnMaterial,
    STRAIGHT_LEFT: roadSignStraightLeftMaterial,
    STRAIGHT_LEFT_RIGHT: roadSignStraightLeftRightMaterial,
    STRAIGHT: roadSignStraightMaterial,
    STRAIGHT_UTURN: roadSignStraightUTurnMaterial,
    UTURN: roadSignUTurnMaterial,
}

const createRoadMarkSvgMeshByType = (typeKey, scale) => {
    const material = ROAD_MARK_SIGN_MATERIAL_BY_TYPE[typeKey]
    const img = material?.map?.image
    if (!img?.width || !img?.height) return null
    const aspect = img.width / img.height
    const h = Math.max(0.45, scale * 1.35)
    const w = h * aspect
    const mesh = new THREE.Mesh(new THREE.PlaneGeometry(w, h), material)
    mesh.renderOrder = 102
    return mesh
}

const pointToSegmentDistSq = (px, py, x1, y1, x2, y2) => {
    const dx = x2 - x1
    const dy = y2 - y1
    const L2 = dx * dx + dy * dy
    if (L2 < 1e-18) {
        return (px - x1) ** 2 + (py - y1) ** 2
    }
    let t = ((px - x1) * dx + (py - y1) * dy) / L2
    t = Math.max(0, Math.min(1, t))
    const cx = x1 + t * dx
    const cy = y1 + t * dy
    return (px - cx) ** 2 + (py - cy) ** 2
}

/** 取车道首点到尾点的整体方向 */
const localMapLaneForwardXYFromElement = (lane) => {
    const pts = lane?.pointList
    if (!pts || pts.length < 2) return null
    const last = pts[pts.length - 1]
    const first = pts[0]
    const fx = last.x - first.x
    const fy = last.y - first.y
    const L2 = fx * fx + fy * fy
    if (L2 < 1e-8) return null
    const inv = 1 / Math.sqrt(L2)
    return new THREE.Vector2(fx * inv, fy * inv)
}

const getVehicleForwardUnitXY = () => {
    const yaw = Number(store.state.wsModule.data?.vehicleData?.vehicle?.orientation?.z)
    if (!Number.isFinite(yaw)) return new THREE.Vector2(0, 1)
    return new THREE.Vector2(Math.cos(yaw), Math.sin(yaw))
}

/**
 * 在 reference 处找同车道车道，取该车道的整体方向作为直行基准。
 * 用于每条 road_mark 各自相对 lane 的方位（直行/左转等为相对角）。
 */
const getRoadMarkLaneForwardUnitXY = (laneList, refX, refY, roadMarkId) => {
    const px = Number(refX)
    const py = Number(refY)
    const cacheKey = roadMarkId ?? `${px}_${py}`
    if (!Number.isFinite(px) || !Number.isFinite(py)) {
        return roadMarkForwardCache.get(cacheKey)?.clone?.() || getVehicleForwardUnitXY()
    }

    let bestLane = null
    const thresholdSq = ROAD_MARK_LANE_MATCH_THRESHOLD * ROAD_MARK_LANE_MATCH_THRESHOLD
    if (laneList?.length) {
        for (const lane of laneList) {
            const pts = lane.pointList || []
            for (let i = 0; i < pts.length - 1; i++) {
                const a = pts[i]
                const b = pts[i + 1]
                const d2 = pointToSegmentDistSq(px, py, a.x, a.y, b.x, b.y)
                if (d2 <= thresholdSq) {
                    bestLane = lane
                    break
                }
            }
            if (bestLane) break
        }
    }
    const fwd = bestLane ? localMapLaneForwardXYFromElement(bestLane) : null
    if (fwd) {
        roadMarkForwardCache.set(cacheKey, fwd.clone())
        return fwd.clone()
    }
    return roadMarkForwardCache.get(cacheKey)?.clone?.() || getVehicleForwardUnitXY()
}

export const setRoadMarkLocalLaneList = (laneList) => {
    roadMarkLocalLaneList = Array.isArray(laneList) ? laneList : null
}

const load_map_line_all_local_navi = (lineData, lineType) => {
    if (!lineData) return
    const setting = getMapSettingByType(lineType)
    if (!setting?.group) return

    while (setting.group.children.length > 0) {
        const child = setting.group.children.pop()
        disposeO3D(child)
    }
    setting.mapObject?.clear?.()

    lineData.forEach((el) => {
        const pts = el?.pointList || []
        if (pts.length < 2) return
        const isHighLight = !!el?.enableHighLight
        const naviPts = pts.map((p) => ({
            x: Number(p?.x) || 0,
            y: Number(p?.y) || 0,
            z:  Number(p?.z),
        }))
        const meshOutlinePoints = createMeshFromLine(naviPts, isHighLight ? 0.22 : 0.08)
        if (!meshOutlinePoints || meshOutlinePoints.length < 3) return
        const heartShape = new THREE.Shape()
        meshOutlinePoints.forEach((p, idx) => {
            if (idx === 0) heartShape.moveTo(p.x, p.y)
            else heartShape.lineTo(p.x, p.y)
        })
        const geometry = new THREE.ShapeGeometry(heartShape)
        const material = new THREE.MeshBasicMaterial({
            color: isHighLight ? 0x00ffff : 0x00a8b8,
            transparent: true,
            opacity: isHighLight ? 1 : 0.8,
            side: THREE.DoubleSide,
            depthTest: false,
            depthWrite: false,
            blending: THREE.NormalBlending,
            toneMapped: false,
        })
        const line = new THREE.Mesh(geometry, material)
        line.position.set(0, 0, 0.02)
        line.renderOrder = isHighLight ? 330 : 320

        if (isHighLight) {
            // 与主线同宽的同 geometry 发光层：只提亮，不改变总体宽度
            const glowMaterial = new THREE.MeshBasicMaterial({
                color: 0x00ffff,
                transparent: true,
                opacity: 0.28,
                side: THREE.DoubleSide,
                depthTest: true,
                depthWrite: false,
                blending: THREE.AdditiveBlending,
                toneMapped: false,
            })
            const glowMesh = new THREE.Mesh(geometry.clone(), glowMaterial)
            glowMesh.position.set(0, 0, -0.0005)
            glowMesh.renderOrder = 329
            line.add(glowMesh)

            const coreMaterial = new THREE.MeshBasicMaterial({
                color: 0x9fffff,
                transparent: true,
                opacity: 0.18,
                side: THREE.DoubleSide,
                depthTest: true,
                depthWrite: false,
                blending: THREE.AdditiveBlending,
                toneMapped: false,
            })
            const coreMesh = new THREE.Mesh(geometry.clone(), coreMaterial)
            coreMesh.position.set(0, 0, 0.0003)
            coreMesh.renderOrder = 331
            line.add(coreMesh)
        }

        const last = naviPts[naviPts.length - 1]
        const prev = naviPts[naviPts.length - 2]
        const direction = new THREE.Vector3(
            last.x - prev.x,
            last.y - prev.y,
            0
        )
        if (direction.lengthSq() > 1e-8) {
            direction.normalize()
            const arrowOrigin = new THREE.Vector3(last.x, last.y, 0.035)
            const arrow = new THREE.ArrowHelper(
                direction,
                arrowOrigin,
                1.1,
                0xff0000,
                0.42,
                0.22
            )
            arrow.renderOrder = isHighLight ? 331 : 321
            arrow.line.material.depthTest = false
            arrow.cone.material.depthTest = false
            line.add(arrow)
        }

        setting.group.add(line)
        if (el?.id != null) setting.mapObject.set(el.id, line)
    })
}

/** road_mark 方向图形：优先按 RoadMarkType 走对应的 SVG */
const createRoadMarkAnglesArrowGroup = (element, laneList) => {
    const typeKey = ROAD_MARK_TYPE_ENUM[Number(element.type)]
    if (!typeKey) return null   

    const pts = element.pointList || []
    if (pts.length === 0) return null
    const minX = Math.min(...pts.map((p) => p.x))
    const maxX = Math.max(...pts.map((p) => p.x))
    const minY = Math.min(...pts.map((p) => p.y))
    const maxY = Math.max(...pts.map((p) => p.y))
    const cx = (minX + maxX) / 2
    const cy = (minY + maxY) / 2
    const spanX = Math.max(maxX - minX, 0.001)
    const spanY = Math.max(maxY - minY, 0.001)
    const minSpan = Math.min(spanX, spanY)
    const forward = getRoadMarkLaneForwardUnitXY(laneList, cx, cy, element.id)
    const baseRotation = Math.atan2(-forward.x, forward.y)
    const arrowScale = Math.max(0.25, minSpan * 0.42)

    const group = new THREE.Group()
    group.position.set(cx, cy, 0.022)

    const signTypeKey = typeKey === 'RIGHT'
        ? 'LEFT'
        : (typeKey === 'STRAIGHT_RIGHT' ? 'STRAIGHT_LEFT' : typeKey)
    const mesh = createRoadMarkSvgMeshByType(signTypeKey, arrowScale)
    if (!mesh) return null
    if (typeKey === 'RIGHT' || typeKey === 'STRAIGHT_RIGHT') {
        mesh.scale.x = -1
    }
    mesh.rotation.z = baseRotation
    group.add(mesh)
    return group
}

const attachRoadMarkDirectionGraphics = (line, el, laneList) => {
    const g = createRoadMarkAnglesArrowGroup(el, laneList)
    if (g) line.add(g)
}

//全图 
export const renderMap_all = (mapData, scene, mapLabelMap_in, mapLabelMap_visible_in, elementSetting_in) => {
    if (!mapData) return
    scene_global = scene;
    mapLabelMap = mapLabelMap_in
    mapLabelMap_visible = mapLabelMap_visible_in
    elementSetting = elementSetting_in
    const laneListForRoadMark = (mapData.laneList?.length > 0)
        ? mapData.laneList
        : (roadMarkLocalLaneList?.length > 0 ? roadMarkLocalLaneList : null)
    load_map_line_all_local_navi(mapData.localNaviLineList, 'local_navi_line')
    load_map_line_all(mapData.entryLineList, 'entry_line')
    load_map_line_all(mapData.stopLineList, 'stop_line') //已完成 1，停止线
    load_map_line_all_boundary(mapData.boundaryList, 'boundary') //有几个类型没有特别设计 2 ，边界
    load_map_line_all_roadmark(mapData.roadMarkList, 'road_mark', laneListForRoadMark) //已完成 1，停止线
    load_map_line_all_layer_num(mapData.laneList, 'lane') //已完成   3，行车线
    load_map_mesh_all(mapData.clearZoneList, 'clear_zone') //4，禁停区
    load_map_mesh_all(mapData.crossWalkList, 'cross_walk') //已完成，,5，人行横道
    load_map_mesh_all(mapData.freeAreaList, 'free_area') //6，自由停车区，
    load_map_line_all(mapData.gateList, 'gate') //未完成，缺真实数据,7，小区门、栏杆，
    load_map_line_all(mapData.intersectionList, 'intersection') //已完成,8，路口  //todo 也可以描绘成面
    load_map_mesh_all(mapData.parkingList, 'parking') //9，停车位，
    load_map_mesh_all(mapData.pillarList, 'pillar') //已完成，10，石墩
    load_map_mesh_all(mapData.prohibitedAreaList, 'prohibited_area') //已完成 11，禁行区
    load_map_mesh_all(mapData.speedBumpList, 'speed_bump') //已完成,13，减速带，
    load_map_mesh_all(mapData.safetyIslandList, 'safety_island') //缺真实数据,12，安全岛，
    load_map_mesh_all(mapData.multiLayerAreaList, 'multiLayerArea') //19，多楼层区域
}

const load_map_mesh_all = (data, type) => {
    Promise.resolve().then(() => {
        const setting = getMapSettingByType(type)
        data?.forEach((el) => {
            if (!setting.mapObject.has(el.id)) {
                const mesh = createMesh({
                    name: type,
                    element: el
                })
                if (mesh) {
                    if (!setting.mapObject.has(el.id)) {
                        createLable(el).then((elementLabel) => {
                            mesh.add(elementLabel)
                        })
                        mesh.positionEX = el.pointList[0]
                        mesh.renderOrder = -20
                        setting.group.add(mesh)
                        setting.mapObject.set(el.id, mesh)
                    } else {
                        mesh.geometry.dispose()
                    }
                }
            }
        })
    })
}

/**
* 加载线性元素
*/
const load_map_line_all_roadmark = (lineData, lineType, laneListForRoadMark) => {
    if (!lineData) return
    
    const setting = getMapSettingByType(lineType)

    lineData.forEach((el) => {
        if (!setting.mapObject.has(el.id)) {
            const line = createLinePath({
                name: lineType,
                type: el.type,
                element: el,
            })
            if (line) {
                if (!setting.mapObject.has(el.id)) {
                    createLable(el).then((elementLabel) => {
                        line.add(elementLabel)
                    })
                    createRoadMarkTypeLabel(el).then((typeLabel) => {
                        if (typeLabel) line.add(typeLabel)
                    })
                    attachRoadMarkDirectionGraphics(line, el, laneListForRoadMark)
                    line.dataSource = el
                    setting.group.add(line)
                    setting.mapObject.set(el.id, line)
                } else {
                    line.geometry.dispose()
                }
            }
        }
    })
}

/**
* 加载线性元素
*/
const load_map_line_all_boundary = (lineData, lineType, center) => {
    if (!lineData) return
    const setting = getMapSettingByType(lineType)
    lineData.forEach((el) => {
        if (!setting.mapObject.has(el.id)) {
            const line = createLine_boundary({
                name: lineType,
                type: el.type,
                element: el
            })
            if (line) {
                if (!setting.mapObject.has(el.id)) {
                    createLable(el).then((elementLabel) => {
                        line.add(elementLabel)
                    })
                    line.dataSource = el
                    setting.group.add(line)
                    setting.mapObject.set(el.id, line)
                } else {
                    line.geometry.dispose()
                }
            }
        }
    })
}
/**
* 加载线性元素
*/
const load_map_line_all = (lineData, lineType) => {
    if (!lineData) return

    const setting = getMapSettingByType(lineType)
    lineData.forEach((el) => {
        if (!setting.mapObject.has(el.id)) {
            const line = createLine({
                name: lineType,
                type: el.type,
                element: el
            })
            if (line) {
                if (!setting.mapObject.has(el.id)) {
                    createLable(el).then((elementLabel) => {
                        line.add(elementLabel)
                    })
                    line.dataSource = el
                    setting.group.add(line)
                    setting.mapObject.set(el.id, line)
                } else {
                    line.geometry.dispose()
                }
            }
        }
    })
}
/**
* 加载线性元素 带楼层的lane 单独处理
*/
const load_map_line_all_layer_num = (lineData, lineType) => {
    if (!lineData) return
    Promise.resolve().then(() => {
        const setting = getMapSettingByType(lineType)
        lineData.forEach((el) => {
            if (!setting.mapObject.has(el.id)) {
                let distance = el.pointList
                if (distance) {
                    const line = createLine({
                        name: lineType,
                        type: el.type,
                        element: el
                    })
                    if (line) {
                        if (!setting.mapObject.has(el.id)) {
                            createLable(el).then((elementLabel) => {
                                line.add(elementLabel)
                            })
                            setting.group.add(line)
                            setting.mapObject.set(el.id, line)
                        } else {
                            line.geometry.dispose()
                        }
                    }
                }
            }
        })
    })
}

/**
 * 获取不同类型的地图元素配置
 */
export const getMapSettingByType = (typeName) => {
    let setting = elementSetting.mapSetting_topic[typeName]
    if (!setting) return
    if (!setting.group) {
        setting.group = new THREE.Group()
        setting.group.visible = setting.visible
        setting.z = setting.z || 0
        setting.group.position.set(0, 0, setting.z)
        scene_global.add(setting.group)
    }
    if (!setting.mapObject) {
        setting.mapObject = new Map()
    }
    return setting
}

let promise_TrafficLightTexture = null
const getTrafficLightTexture = () => {
    if (promise_TrafficLightTexture) return promise_TrafficLightTexture
    return new Promise((resolve, reject) => {
        const loader = new THREE.TextureLoader()
        loader.load(
            // 资源URL
            trafficlight_png,
            // onLoad回调
            (texture) => {
                // in this example we create the material when the texture is loaded
                const material = new THREE.MeshBasicMaterial({
                    map: texture
                    // side: THREE.DoubleSide
                })
                resolve(material)
            },
            // 目前暂不支持onProgress的回调
            undefined,
            // onError回调
            function (err) {
                console.error(err)
                reject(err)
            }
        )
    })
}


const roadMarkTypeLabelKey = (id) => `road_mark_type_${id}`

const createRoadMarkTypeLabel = (mapElement) => {
    const key = roadMarkTypeLabelKey(mapElement.id)
    const label_size = Number(store.state.wsModule.label_size || 5) * 6
    const green = '#22c55e'
    const typeNum = Number(mapElement.type)
    const typeName = ROAD_MARK_TYPE_ENUM[typeNum] || `UNKNOWN_${mapElement.type}`
    return new Promise((resolve) => {
        if (mapLabelMap.has(key)) {
            const element = mapLabelMap.get(key)
            if (element._typeName === typeName) {
                element.visible = mapLabelMap_visible
                resolve(element)
                return
            }
            mapLabelMap.delete(key)
        }
        const pts = mapElement.pointList || []
        if (pts.length === 0) {
            resolve(null)
            return
        }
        const minX = Math.min(...pts.map((p) => p.x))
        const maxX = Math.max(...pts.map((p) => p.x))
        const minY = Math.min(...pts.map((p) => p.y))
        const maxY = Math.max(...pts.map((p) => p.y))
        const spanX = Math.max(maxX - minX, 0.001)
        const spanY = Math.max(maxY - minY, 0.001)
        const insetX = Math.max(spanX * 0.16, 0.22)
        const insetY = Math.max(spanY * 0.16, 0.22)
        const element = createSpriteText_map([typeName], label_size, green)
        element._typeName = typeName
        // 避开 createLable 的中心点，放在 road_mark 框内偏右下
        element.position.set(maxX - insetX, minY + insetY, 0.045)
        element.up = new THREE.Vector3(0, 0, 1)
        element.renderOrder = 101
        mapLabelMap.set(key, element)
        element.visible = mapLabelMap_visible
        resolve(element)
    })
}

const createLable = (mapElement) => {
    let label_size = Number(store.state.wsModule.label_size || 5) * 6;
    return new Promise((resolve, reject) => {
        if (mapLabelMap.has(mapElement.id)) {
            let element = mapLabelMap.get(mapElement.id)
            element.visible = mapLabelMap_visible
            resolve(element)
        } else {
            let center = getCenterFromArray(mapElement.pointList)
            let element = createSpriteText_map([mapElement.id], label_size);
            element.position.set(center.x, center.y, center.z)
            element.up = new THREE.Vector3(0, 0, 1)
            if (!mapLabelMap.has(mapElement.id)) {
                mapLabelMap.set(mapElement.id, element)
                element.visible = mapLabelMap_visible
                resolve(element)
            } else {
                let element = mapLabelMap.get(mapElement.id)
                element.visible = mapLabelMap_visible
                resolve(element)
            }
        }
    })
}

const createLable_trafficLight = (mapElement) => {
    let label_size = Number(store.state.wsModule.label_size || 5) * 6;
    return new Promise((resolve, reject) => {
        if (mapLabelMap.has(mapElement.id)) {
            let element = mapLabelMap.get(mapElement.id)
            element.visible = mapLabelMap_visible
            resolve(element)
        } else {
            let element = createSpriteText_map([mapElement.id], label_size);
            element.position.set(0, 0, 1)
            element.up = new THREE.Vector3(0, 0, 1)
            if (!mapLabelMap.has(mapElement.id)) {
                mapLabelMap.set(mapElement.id, element)
                element.visible = mapLabelMap_visible
                resolve(element)
            } else {
                let element = mapLabelMap.get(mapElement.id)
                element.visible = mapLabelMap_visible
                resolve(element)
            }
        }
    })
}
const getCenterFromArray = (polygonList = []) => {
    if (polygonList.length > 0) {
        let index = Math.floor(polygonList.length / 2);
        let center = {
            x: polygonList[index].x,
            y: polygonList[index].y
        }
        return center
    } else {
        return { x: 0, y: 0 }
    }
}

export const setMapVisible = (isVisible) => {
    if (elementSetting) {
        for (let item in elementSetting.mapSetting_topic) {
            elementSetting.mapSetting_topic[item].visible = isVisible
            if (elementSetting.mapSetting_topic[item].group)
                elementSetting.mapSetting_topic[item].group.visible =
                    elementSetting.mapSetting_topic[item].visible
        }
    }
}

export const clearMapGroup = () => {
    if (!elementSetting) {
        return
    }
    for (let attributeName in elementSetting.mapSetting_topic) {
        let element = elementSetting.mapSetting_topic[attributeName]
        if (element) {
            if (element.group) {
                disposeO3D(element.group)
                element.group = null
            }
            if (element.mapObject) {
                element.mapObject.clear()
            }
        }
    }
}

/**
 * 裁剪全图，从position位置，裁剪出一个300范围的小图；
 * @param {*} mapData 
 * @param {*} position 
 * @returns 
 */
export const filterMapAll = (mapData, position) => {
    if (!mapData) {
        return;
    }
    // let mapData = mapDataObject.vct
    let mapData_filter = {};
    mapData_filter.stopLineList = filter_map_line_all(mapData.stopLineList, position) //已完成 1，停止线
    mapData_filter.boundaryList = filter_map_line_all(mapData.boundaryList, position) //有几个类型没有特别设计 2 ，边界
    mapData_filter.roadMarkList = filter_map_line_all(mapData.roadMarkList, position) //有几个类型没有特别设计 2 ，边界
    mapData_filter.laneList = filter_map_line_all(mapData.laneList, position) //已完成   3，行车线
    mapData_filter.clearZoneList = filter_map_line_all(mapData.clearZoneList, position) //4，禁停区
    mapData_filter.crossWalkList = filter_map_line_all(mapData.crossWalkList, position) //已完成，,5，人行横道
    mapData_filter.freeAreaList = filter_map_line_all(mapData.freeAreaList, position) //6，自由停车区，
    mapData_filter.gateList = filter_map_line_all(mapData.gateList, position) //未完成，缺真实数据,7，小区门、栏杆，
    mapData_filter.intersectionList = filter_map_line_all(mapData.intersectionList, position) //已完成,8，路口  //todo 也可以描绘成面
    mapData_filter.parkingList = filter_map_line_all(mapData.parkingList, position) //9，停车位，
    mapData_filter.pillarList = filter_map_line_all(mapData.pillarList, position) //已完成，10，石墩
    mapData_filter.prohibitedAreaList = filter_map_line_all(mapData.prohibitedAreaList, position) //已完成 11，禁行区
    mapData_filter.speedBumpList = filter_map_line_all(mapData.speedBumpList, position) //已完成,13，减速带，
    mapData_filter.safetyIslandList = filter_map_line_all(mapData.safetyIslandList, position) //缺真实数据,12，安全岛
    mapData_filter.multiLayerAreaList = filter_map_line_all(mapData.multiLayerAreaList, position) //19，多楼层区域
    mapData_filter.trafficLightList = filter_map_trafficLightList(mapData.trafficLightList, position) //缺真实数据,12，安全岛)   
    return mapData_filter;
    // if (!mapDataObject || !mapDataObject.vct) {
    //     return;
    // }
    // if (mapDataObject.type == 1) {
    //     //整图
    //     let mapData = mapDataObject.vct
    //     let mapData_filter = {};
    //     mapData_filter.stopLineList = filter_map_line_all(mapData.stopLineList, position) //已完成 1，停止线
    //     mapData_filter.boundaryList = filter_map_line_all(mapData.boundaryList, position) //有几个类型没有特别设计 2 ，边界
    //     mapData_filter.laneList = filter_map_line_all(mapData.laneList, position) //已完成   3，行车线
    //     mapData_filter.clearZoneList = filter_map_line_all(mapData.clearZoneList, position) //4，禁停区
    //     mapData_filter.crossWalkList = filter_map_line_all(mapData.crossWalkList, position) //已完成，,5，人行横道
    //     mapData_filter.freeAreaList = filter_map_line_all(mapData.freeAreaList, position) //6，自由停车区，
    //     mapData_filter.gateList = filter_map_line_all(mapData.gateList, position) //未完成，缺真实数据,7，小区门、栏杆，
    //     mapData_filter.intersectionList = filter_map_line_all(mapData.intersectionList, position) //已完成,8，路口  //todo 也可以描绘成面
    //     mapData_filter.parkingList = filter_map_line_all(mapData.parkingList, position) //9，停车位，
    //     mapData_filter.pillarList = filter_map_line_all(mapData.pillarList, position) //已完成，10，石墩
    //     mapData_filter.prohibitedAreaList = filter_map_line_all(mapData.prohibitedAreaList, position) //已完成 11，禁行区
    //     mapData_filter.speedBumpList = filter_map_line_all(mapData.speedBumpList, position) //已完成,13，减速带，
    //     mapData_filter.safetyIslandList = filter_map_line_all(mapData.safetyIslandList, position) //缺真实数据,12，安全岛
    //     mapData_filter.trafficLightList = filter_map_trafficLightList(mapData.trafficLightList, position) //缺真实数据,12，安全岛)   
    //     return mapData_filter;
    // }else{
    //     //分幅
    // }

}
const filter_map_line_all = (alldata, origin) => {
    return alldata.filter(el => {
        if (el.pointList.length <= 0) {
            return false;
        }
        let index = Math.floor(el.pointList.length / 2);
        return Math.abs(el.pointList[index].x - origin.x) < 300 && (Math.abs(el.pointList[index].y - origin.y) < 300)
    })
}
const filter_map_trafficLightList = (alldata, origin) => {
    return alldata.filter(e => (Math.abs(e.position.x - origin.x) < 300) && (Math.abs(e.position.y - origin.y) < 300));
}

//delete
export const renderMap = (mapData, scene, mapLabelMap_in, mapLabelMap_visible_in, elementSetting_in) => {
    //已完成
    scene_global = scene;
    mapLabelMap = mapLabelMap_in
    mapLabelMap_visible = mapLabelMap_visible_in
    elementSetting = elementSetting_in
    load_map_line(mapData.stopLineList, 'stop_line') //已完成 1，停止线
    load_map_line(mapData.boundaryList, 'boundary') //有几个类型没有特别设计 2 ，边界
    load_map_line(mapData.laneList, 'lane') //已完成   3，行车线
    load_map_mesh(mapData.clearZoneList, 'clear_zone') //4，禁停区
    load_map_line(mapData.roadMarkList, 'road_mark', mapData.laneList) //已完成   3，行车线
    load_map_mesh(mapData.crossWalkList, 'cross_walk') //已完成，,5，人行横道
    load_map_mesh(mapData.freeAreaList, 'free_area') //6，自由停车区，
    load_map_line(mapData.gateList, 'gate') //未完成，缺真实数据,7，小区门、栏杆，
    load_map_line(mapData.intersectionList, 'intersection') //已完成,8，路口  //todo 也可以描绘成面
    load_map_mesh(mapData.parkingList, 'parking') //9，停车位，
    load_map_mesh(mapData.pillarList, 'pillar') //已完成，10，石墩
    load_map_mesh(mapData.prohibitedAreaList, 'prohibited_area') //已完成 11，禁行区
    load_map_mesh(mapData.speedBumpList, 'speed_bump') //已完成,13，减速带，
    load_map_mesh(mapData.safetyIslandList, 'safety_island') //缺真实数据,12，安全岛，
    load_map_trafficLight(mapData.trafficLightList, 'traffic_light') //红绿灯
}
/**
* 加载线性元素
*/
const load_map_line = (lineData, lineType, laneListForRoadMark) => {
    if (!lineData) return
    Promise.resolve().then(() => {
        const setting = getMapSettingByType(lineType)
        for (let [key, value] of setting.mapObject) {
            //删除的
            let ele = lineData.find((element) => element.id == key)
            if (!ele) {
                var pos1 = new THREE.Vector3(origin.x, origin.y, 0)
                var pos2 = new THREE.Vector3(value.positionEX.x, value.positionEX.y, 0)
                var distance = pos1.distanceTo(pos2)
                if (distance > 200) {
                    setting.group.remove(value)
                    value.geometry.dispose()
                    setting.mapObject.delete(key)
                }
            }
        }
        lineData.forEach((el) => {
            if (!setting.mapObject.has(el.id)) {
                const line = createLine({
                    name: lineType,
                    type: el.type,
                    element: el
                })
                if (line) {
                    if (!setting.mapObject.has(el.id)) {
                        createLable(el).then((elementLabel) => {
                            line.add(elementLabel)
                        })
                        if (lineType === 'road_mark') {
                            createRoadMarkTypeLabel(el).then((typeLabel) => {
                                if (typeLabel) line.add(typeLabel)
                            })
                            attachRoadMarkDirectionGraphics(line, el, laneListForRoadMark)
                        }
                        setting.group.add(line)
                        setting.mapObject.set(el.id, line)
                    }
                }
            }
        })
    })
}
/**
 * 加载红绿灯
 */
const load_map_trafficLight = (lineData = [], lineType) => {
    if (lineData && lineData.length > 0) {
        const setting = getMapSettingByType(lineType)
        lineData.forEach((e) => {
            if (!setting.mapObject.has(e.id)) {
                getTrafficLightTexture().then((material) => {
                    const geometry = new THREE.BoxGeometry(2, 0.1, 1)
                    const cube = new THREE.Mesh(geometry, material)
                    cube.position.set(e.position.x, e.position.y, e.position.z)
                    cube.rotation.set(0, 0, Math.PI + (e.angle/ 180) * Math.PI)
                    if (!setting.mapObject.has(e.id)) {
                        setting.mapObject.set(e.id, cube)
                        setting.group.add(cube)
                    }
                })
            }
        })
    }
}

/**
 * 加载面元素
 */
const load_map_mesh = (data, type) => {
    Promise.resolve().then(() => {
        const setting = getMapSettingByType(type)
        for (let [key, value] of setting.mapObject) {
            //删除的
            let ele = data.find((element) => element.id == key)
            if (!ele) {
                var pos1 = new THREE.Vector3(origin.x, origin.y, 0)
                var pos2 = new THREE.Vector3(value.positionEX.x, value.positionEX.y, 0)
                var distance = pos1.distanceTo(pos2)
                if (distance > 200) {
                    setting.group.remove(value)
                    value.geometry.dispose()
                    setting.mapObject.delete(key)
                }
            }
        }
        data.forEach((el) => {
            if (!setting.mapObject.has(el.id)) {
                const mesh = createMesh({
                    name: type,
                    element: el
                })
                if (mesh) {
                    if (!setting.mapObject.has(el.id)) {
                        createLable(el).then((elementLabel) => {
                            mesh.add(elementLabel)
                        })
                        mesh.positionEX = el.pointList[0]
                        mesh.renderOrder = -20
                        setting.group.add(mesh)
                        setting.mapObject.set(el.id, mesh)
                    }
                }
            }
        })
    })
}

let active_map_ele_side = null;
let active_map_ele_material = null;
export const active_map_ele = () => {
    let mapSearchItem = store.state.wsModule.mapSearchItem;
    if (!mapSearchItem) {
        if (active_map_ele_side) {
            disposeO3D(active_map_ele_side);
        }
        return;
    } else {
        let new_active_map_ele_side = active_map_element(mapSearchItem.type, JSON.parse(mapSearchItem.data))
        if (new_active_map_ele_side) {
            if (active_map_ele_side) {
                disposeO3D(active_map_ele_side);
            }
            active_map_ele_side = new_active_map_ele_side;
        }
        return new_active_map_ele_side
    }
}

const active_map_element = (type, data) => {
    let result = null;
    switch (type) {
        case "laneList":
        case "stopLineList":
        case "intersectionList":
        case "boundaryList":
        case "roadMarkList":
        case "freeAreaList":
        case "crossWalkList":
        case "crossWalkList":
        case "safetyIslandList":
            result = active_map_line(data)
            break;
        case "trafficLightList":
            result = active_map_trafficLight(data);
            break;
        default:
            console.log("暂不支持");
    }
    return result;
}
const active_map_line = (data) => {
    //lane   StopLine  pointList
    //Intersection pointList 闭合的
    let heartShape = new THREE.Shape()
    let pointsList = createMeshFromLine(data.pointList, 0.3)
    pointsList.forEach((e, index) => {
        if (index == 0) {
            heartShape.moveTo(e.x, e.y)
        } else {
            heartShape.lineTo(e.x, e.y)
        }
    })

    const geometry_shape = new THREE.ShapeGeometry(heartShape)
    if (!active_map_ele_material) {
        active_map_ele_material = new THREE.MeshBasicMaterial({
            color: 0xef4136,
            side: THREE.DoubleSide
        })
    }
    const mesh = new THREE.Mesh(geometry_shape, active_map_ele_material)
    mesh.position.set(0, 0, 0.011)
    mesh.renderOrder = -10
    mesh.center = getCenter(data.pointList);
    if (scene_global) {
        scene_global.add(mesh)
    }
    return mesh;
}
const active_map_trafficLight = (data) => {
    const geometry = new THREE.BoxGeometry(2, 0.3, 1)
    if (!active_map_ele_material) {
        active_map_ele_material = new THREE.MeshBasicMaterial({
            color: 0xf173ac,
            side: THREE.DoubleSide
        })
    }
    const cube = new THREE.Mesh(geometry, active_map_ele_material)
    cube.position.set(data.position.x, data.position.y, data.position.z)
    cube.rotation.set(0, 0, Math.PI + (data.angle / 180) * Math.PI)
    cube.center = data.position;
    if (scene_global) {
        scene_global.add(cube)
    }
    return cube;
}
const getCenter = (pointList = []) => {
    if (!pointList || pointList.length == 0) {
        return null;
    }
    let sum = pointList.reduce((pre, cur) => {
        return { x: pre.x + cur.x, y: pre.y + cur.y }
    }, { x: 0, y: 0 })
    let center = {
        x: sum.x / pointList.length,
        y: sum.y / pointList.length
    }
    return center;
}

